import actionTypes from "constants/carChat";
import { Action, ActionFunctionAny, createActions } from "redux-actions";
import { setMessagesAsRead } from "sources/carChats";

const { READ_ALL_CAR_CHATS, READ_CAR_CHAT, TOGGLE_FAVORITE_CAR_CHAT } = actionTypes;

const actions = createActions(READ_ALL_CAR_CHATS, READ_CAR_CHAT, TOGGLE_FAVORITE_CAR_CHAT);

const readAllCarChats = () => (dispatch: ActionFunctionAny<Action<Object>>) =>
    setMessagesAsRead({}).then(() => dispatch(actions.readAllCarChats()));

const readCarChat = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    setMessagesAsRead(params).then(() => dispatch(actions.readCarChat(params)));

const toggleFavorite = (params: {}) => (dispatch: ActionFunctionAny<Action<Object>>) =>
    dispatch(actions.toggleFavoriteCarChat(params));

export default { ...actions, readAllCarChats, readCarChat, toggleFavorite };
